import React from 'react'
import Reflux from 'reflux'

const stepsPadding = {
    padding: '0 238px 0px 238px'
}

class HeaderSteps extends Reflux.Component {

    constructor(props) {
        super(props)
        this.state = {
            currentStep: props.currentStep,
        }
    }

    setStep = (step) => {
        this.props.setStep(step);
    }

    render() {
        return (
            <div className="steps-container">
                <div className="container">
                    <div className="row ">
                        <ul className="breadcrumb">
                            <li onClick={(step) => this.setStep(1)}>
                                <a style={stepsPadding} className='visited'>1. Feltöltés</a>
                            </li>
                            <li>
                                <a style={stepsPadding} className={this.state.currentStep > 1 ? 'visited' : ''}>2. Letöltés</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default HeaderSteps


// WEBPACK FOOTER //
// ./src/components/cashregister/headersteps.js